var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 108,
    height: 107,
    viewBox: "0 0 108 107",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1074",
    "data-name": "Group 1074",
    transform: "translate(-6 -3325)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "\\u2605",
    transform: "translate(60 3419)",
    fill: "red",
    fontSize: 107,
    fontFamily: "HiraginoSans-W3, Hiragino Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -53.5,
    y: 0
  }, "\u2605")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedStar);
export default __webpack_public_path__ + "static/media/red-star.00f629ce7f2a5ac500fe53ee3e531f51.svg";
export { ForwardRef as ReactComponent };